import { productCardType } from '@/commonTypes';
import React from 'react';
import styles from './styles.module.css';
import SideBar from '../SideBar';
import ProductMenuSection from '../ProductMenuSection';

export default function ProductDetailsSection({ product }: { product?: productCardType }) {
  return (
    <div className={`${styles.container}`}>
      <ProductMenuSection data={product} />
      <SideBar />
    </div>
  );
}
